import { z } from "zod";

export function raidSchema(requiresConfiguredRaid: boolean) {
  return z
    .object({
      date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Ogiltigt datum"),
      title: z
        .string()
        .trim()
        .min(1, "Titel krävs")
        .max(100, "Högst 100 tecken"),
      startTime: z
        .string()
        .regex(/^\d{2}:\d{2}$/, "Ogiltig tid")
        .transform((value) => `${value}:00`),
      description: z.string().trim().max(500, "Högst 500 tecken"),
      configuredRaidIds: z.array(z.uuid()),
    })
    .superRefine((values, context) => {
      if (requiresConfiguredRaid && values.configuredRaidIds.length === 0) {
        context.addIssue({
          code: "custom",
          message: "Välj minst en raid",
          path: ["configuredRaidIds"],
        });
      }
    });
}

export type RaidFormInput = z.input<ReturnType<typeof raidSchema>>;
export type RaidFormValues = z.output<ReturnType<typeof raidSchema>>;
